import { useEffect, useState } from "react";
import { InputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as BackIcon } from "../../../../assets/svg/icons/back.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";

interface InfoProductIncomingProps {
  task: ITaskProductIncoming | undefined;
}

export default function InfoProductIncoming(task: InfoProductIncomingProps) {
  const [taskProductIncoming, setTaskProductIncoming] = useState<ITaskProductIncoming>();
  const hasSkipReason = taskProductIncoming?.skip_reason != null;

  useEffect(() => {
    setTaskProductIncoming(task.task)
  }, []);

  return (
    <>
      <MessageBalloon text={`Recebeu o Produto?`} />

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi concluída?`} pointed />
        <ButtonYesOrNo onlyResult optionSelected={hasSkipReason ? "no" : "yes"} />
      </div>

      {hasSkipReason ?
        <MessageBalloon text={`${taskProductIncoming?.skip_reason}`} answer />
        :
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <MessageBalloon text={`${taskProductIncoming?.sub_classification} - ${taskProductIncoming?.classification} - ${taskProductIncoming?.manufacturer}`} pointed />

            <div style={{ display: "flex", gap: 10 }}>
              <MessageBalloon text={`${taskProductIncoming?.quantity_ordered}`} />
              <MessageBalloon text={`quilos`} />
            </div>
          </div>

          <InputV2 name="info-product-incoming-kg" type="text" suffix="kg" value={String(taskProductIncoming?.quantity_received ?? 0)} disabled />
        </>
      }
    </>
  )
}
